import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300002,
  parentId: 300000,
  name: "DevOutput",
  label: "Output",
  path: "output",
  icon: "chart",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
